import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {Routes} from '../_enums/routes.enum';

@Injectable({
	providedIn: 'root',
})
export class ErrorPageService {
	public errorMessage: string;
	public errorCode: string;
	public errorTitle: string;
	public redirectTo: Routes;
	public errorId: number;

	setError(errorTitle?: string, errorMessage?: string, errorCode?: string, redirectTo?: Routes, errorId?:number ) {
		this.errorMessage = errorMessage;
		this.errorCode = errorCode;
		this.errorTitle = errorTitle;
		this.redirectTo = redirectTo;
		this.errorId = errorId;
		this.router.navigate([Routes.Error]);
	}

	constructor(private router: Router) {}
}
